import type { StyleRule } from '@archipro-design/aria';
import { pxToRem } from '@archipro-design/aria';
import {
    PADDING_LEFT_RIGHT_SECTION,
    PADDING_TOP_CAPTION_MOBILE,
} from '../pagebuilder.style';

export const TagMainCaptionContainer: StyleRule = ({ theme }) => ({
    '& > div': {
        marginTop: pxToRem(PADDING_TOP_CAPTION_MOBILE),
        width: '100%',
        fontSize: pxToRem(12),
        lineHeight: '125%',
    },

    [theme.screen.laptop]: {
        '& > div': {
            marginTop: pxToRem(48),
            paddingLeft: pxToRem(PADDING_LEFT_RIGHT_SECTION),
            width: '100%',
            fontSize: pxToRem(22),
            lineHeight: '120%',
            overflowWrap: 'break-word',
            fontWeight: 450,
            color: '#161616',
        },
    },
});

export const TagSubCaptionContainer: StyleRule<{
    moduleType?: string;
    isProject?: boolean;
    fullScreen?: boolean | null;
    inViewPort?: boolean;
}> = ({ theme, moduleType, isProject, fullScreen }) => ({
    '& > div': {
        marginTop: pxToRem(PADDING_TOP_CAPTION_MOBILE),
        width: '100%',
        fontSize: pxToRem(12),
        lineHeight: '125%',
    },

    [theme.screen.laptop]: {
        '& > div': {
            marginTop: pxToRem(48),
            marginBottom: pxToRem(125),
            width: '100%',
            fontSize: pxToRem(22),
            lineHeight: '120%',
            color: 'black',
            textAlign: 'left',
            overflowWrap: 'break-word',
            fontWeight: 450,

            ...((moduleType === 'SingleImageModule' ||
                moduleType === 'FullPageGalleryModule') &&
                isProject && {
                    marginTop: pxToRem(48),
                    ...(fullScreen && {
                        display: 'none',
                    }),
                }),
        },
    },
});
